import Logger from '@cdc-internal/fe-toolbox/libs/logger'
import { isProductionBuild, isServerEnv } from '@cdc-internal/fe-toolbox/utils/env'
import { Decimal } from 'decimal.js'

import { isProductionLikeAppEnv } from './env'

export {
  HELP_CENTER_LINK,
  HELP_CENTER_LINKS_MAP,
  LOCAL_STORAGE_NAMESPACE,
  NOT_APPLICABLE,
  REDIRECT_URL_PARAM_KEY,
  SESSION_STORAGE_NAMESPACE,
} from './const'
export { defaultColorScheme } from './ui'

export const logger = new Logger({
  name: 'CDC Market',
  // Output logs in JSON format in production server to adapt to SumoLogic
  outputMode: isServerEnv && isProductionBuild && isProductionLikeAppEnv ? 'json' : 'pretty',
})

logger.info(
  'App Environment: %s | Git Ref: %s | Last commit hash: %s',
  process.env.NEXT_PUBLIC_APP_ENV,
  process.env.NEXT_PUBLIC_GITHUB_REF_NAME,
  process.env.NEXT_PUBLIC_LAST_COMMIT_HASH?.slice(0, 7),
)

export const DecimalWithoutExp = Decimal.clone({ toExpNeg: -100, toExpPos: 100 })
